export default __webpack_public_path__ + "static/media/ExecutiveSummaryPageWithRemovePageOption.d02b21f7.png";